import React from 'react';
import Box from 'components/react-styled-core/Box';
import Image from 'components/react-styled-core/Image';
import i18n from 'lib/i18n';
import { getPublicPath } from 'lib/utils';

const Logo = () => {
    const publicPath = getPublicPath();
    return (
        <Box
            py="md"
            width="108px"
            height="36px"
        >
            <Image
                width="108px"
                height="36px"
                src={`${publicPath}images/img_logo_light.svg`}
                alt={i18n._('Trend Micro')}
            />
        </Box>
    );
};

export default Logo;
